import React from "react"
import { cn } from "utils";

// size = "small" | "medium" | "large"
const Radio = React.forwardRef(({
    label,
    className,
    size = "medium",
    ...rest
}, ref) => {
    const randomId = cn("flexRadioDefault1", String(Math.random() * 10000));
    return (
        <div className={cn("radio-input-container")}>
            <input
                ref={ref}
                className={cn("form-check-input", size, className)}
                type="radio"
                id={randomId}
                {...rest}
            />
            {label && (
                <label
                    for={randomId}
                >
                    {label}
                </label>
            )}
        </div>
    )
});

Radio.displayName = "Radio"

export default Radio;